import { companyActions } from "../../actionTypes";

const initialState = {
	categories: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case companyActions.FETCH_COMPANY_CATEGORIES: {
			return { ...state, fetching: true };
		}

		case companyActions.FETCH_COMPANY_CATEGORIES_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				categories: action.payload,
			};
		}

		case companyActions.FETCH_COMPANY_CATEGORIES_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
